// import React, { useState } from "react";
// import ImageWithBasePath from "../../core/common/imageWithBasePath";
// import { Link, useNavigate } from "react-router-dom";
// import { all_routes } from "../router/all_routes";
// import api from "../../core/axios/axiosInstance";

// type PasswordField = "password" | "confirmPassword";

// const Register = () => {
//   const route = all_routes;
//   const navigate = useNavigate();

//   // Form state
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   const [passwordVisibility, setPasswordVisibility] = useState({
//     password: false,
//     confirmPassword: false,
//   });

//   const getPasswordStrength = (password: string) => {
//     let score = 0;

//     if (password.length >= 8) score++;
//     if (/[A-Z]/.test(password)) score++;
//     if (/[0-9]/.test(password)) score++;
//     if (/[^A-Za-z0-9]/.test(password)) score++;

//     if (score <= 1) return { label: "Weak", color: "danger", value: 25 };
//     if (score === 2) return { label: "Medium", color: "warning", value: 50 };
//     if (score === 3) return { label: "Good", color: "info", value: 75 };
//     return { label: "Strong", color: "success", value: 100 };
//   };

// const passwordStrength = getPasswordStrength(password);

// const isPasswordValid = passwordStrength.value >= 75;
//   const togglePasswordVisibility = (field: PasswordField) => {
//     setPasswordVisibility((prevState) => ({
//       ...prevState,
//       [field]: !prevState[field],
//     }));
//   };
//   // const handleRegister = async (e: React.FormEvent) => {
//   //   e.preventDefault();
//   //   setMessage({ text: "", type: "" });

//   //   if (!password) {
//   //     setMessage({ text: "Password is required", type: "error" });
//   //     return;
//   //   }

//   //   if (password !== confirmPassword) {
//   //     setMessage({ text: "Passwords do not match", type: "error" });
//   //     return;
//   //   }

//   //   if (!email) {
//   //     setMessage({ text: "Email is required", type: "error" });
//   //     return;
//   //   }

//   //   try {
//   //     setIsLoading(true);
//   //     const response = await api.post("user/signup/email", {
//   //       email,
//   //       password,
//   //       confirmPassword,
//   //     });

//   //     if (response.data.status === "success") {
//   //       setMessage({ text: response.data.message, type: "success" });
//   //       // Navigate to login after successful registration
//   //       // setTimeout(() => {
//   //       //   navigate("/");
//   //       // }, 2000);
//   //     }
//   //   } catch (err: any) {
//   //     setMessage({
//   //       text: err?.response?.data?.message || "Registration failed",
//   //       type: "error",
//   //     });
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };

//   const handleRegister = async (e: React.FormEvent) => {
//   e.preventDefault();
//   setMessage({ text: "", type: "" });

//   if (!email) {
//     setMessage({ text: "Email is required", type: "error" });
//     return;
//   }

//   if (!password) {
//     setMessage({ text: "Password is required", type: "error" });
//     return;
//   }

//   // ✅ Check strength before matching
//   const strength = getPasswordStrength(password);

//   if (strength.value < 75) {
//     setMessage({
//       text: "Password must be at least 8 characters and include uppercase, number, and special character.",
//       type: "error",
//     });
//     return;
//   }

//   if (password !== confirmPassword) {
//     setMessage({ text: "Passwords do not match", type: "error" });
//     return;
//   }

//   try {
//     setIsLoading(true);

//     const response = await api.post("user/signup/email", {
//       email,
//       password,
//       confirmPassword,
//     });

//     if (response.data.status === "success") {
//       setMessage({ text: response.data.message, type: "success" });
//     }
//   } catch (err: any) {
//     setMessage({
//       text: err?.response?.data?.message || "Registration failed",
//       type: "error",
//     });
//   } finally {
//     setIsLoading(false);
//   }
// };

//   return (
//     <div className="account-content">
//       <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden ">
//         <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
//           <form className="flex-fill" onSubmit={handleRegister}>
//             <div className="mx-auto mw-450">
//               <div className="text-center mb-4">
//                  <Link to={"https://voycell.com"}>
//                 <ImageWithBasePath
//                   src="assets/img/voycell-logo.webp"
//                   className="img-fluid"
//                   alt="Logo"
//                 />
//                 </Link>
//               </div>
//               <div className="mb-4">
//                 <h4 className="mb-2 fs-20">Register</h4>
//                 <p>Create a new VOYCELL account</p>
//               </div>

//               <div className="mb-3">
//                 <label className="col-form-label">Email Address</label>
//                 <div className="position-relative">
//                   <span className="input-icon-addon">
//                     <i className="ti ti-mail" />
//                   </span>
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     className="form-control"
//                     placeholder="john.doe@example.com"
//                     required
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <label className="col-form-label">Password</label>
//                 <div className="pass-group">
//                   <input
//                     type={passwordVisibility.password ? "text" : "password"}
//                     className="pass-input form-control"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     placeholder="*********"
//                     required
//                   />
//                   <span
//                     className={`ti toggle-passwords ${
//                       passwordVisibility.password ? "ti-eye" : "ti-eye-off"
//                     }`}
//                     onClick={() => togglePasswordVisibility("password")}
//                   ></span>
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <label className="col-form-label">Confirm Password</label>
//                 <div className="pass-group">
//                   <input
//                     type={
//                       passwordVisibility.confirmPassword ? "text" : "password"
//                     }
//                     className="pass-input form-control"
//                     value={confirmPassword}
//                     onChange={(e) => setConfirmPassword(e.target.value)}
//                     placeholder="*********"
//                     required
//                   />
//                   <span
//                     className={`ti toggle-passwords ${
//                       passwordVisibility.confirmPassword
//                         ? "ti-eye"
//                         : "ti-eye-off"
//                     }`}
//                     onClick={() => togglePasswordVisibility("confirmPassword")}
//                   ></span>
//                 </div>
//               </div>
//               {password &&
//                 (() => {
//                   const strength = getPasswordStrength(password);
//                   return (
//                     <div className="my-2">
//                       <div className="progress" style={{ height: "6px" }}>
//                         <div
//                           className={`progress-bar bg-${strength.color}`}
//                           style={{ width: `${strength.value}%` }}
//                         />
//                       </div>
//                       <small className={`text-${strength.color} fw-medium`}>
//                         Password strength: {strength.label}
//                       </small>
//                     </div>
//                   );
//                 })()}
//               {message.text && (
//                 <div className="mb-3">
//                   <div
//                     className={`alert ${
//                       message.type === "success"
//                         ? "alert-success"
//                         : "alert-danger"
//                     } fw-medium`}
//                   >
//                     {message.text}
//                   </div>
//                 </div>
//               )}

//               <div className="d-flex align-items-center justify-content-between mb-3">
//                 <div className="form-check form-check-md d-flex align-items-center">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     defaultValue=""
//                     id="checkebox-md"
//                     defaultChecked
//                   />
//                   <label className="form-check-label" htmlFor="checkebox-md">
//                     I agree to the{" "}
//                     <Link to="#" className="text-primary link-hover">
//                       Terms &amp; Privacy
//                     </Link>
//                   </label>
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <button
//                   type="submit"
//                   className="btn btn-primary w-100"
//                   // disabled={isLoading}
//                   disabled={isLoading || !isPasswordValid}
//                 >
//                   {isLoading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm me-2"
//                         role="status"
//                         aria-hidden="true"
//                       ></span>
//                       Signing Up...
//                     </>
//                   ) : (
//                     "Sign Up"
//                   )}
//                 </button>
//               </div>

//               <div className="mb-3">
//                 <h6>
//                   Already have an account?{" "}
//                   <Link to="/" className="text-purple link-hover">
//                     {" "}
//                     Sign In Instead
//                   </Link>
//                 </h6>
//               </div>

//               <div className="text-center">
//                 <p className="fw-medium text-gray">
//                   Copyright © 2026 - VOYCELL
//                 </p>
//               </div>
//             </div>
//           </form>
//         </div>
//         <div className="d-flex flex-wrap w-50 vh-100  account-bg-02"></div>
//       </div>
//     </div>
//   );
// };

// export default Register;

import React, { useState, useMemo } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import api from "../../core/axios/axiosInstance";

type PasswordField = "password" | "confirmPassword";

const Register = () => {
  const route = all_routes;
  const navigate = useNavigate();

  // Form state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  /* =========================
     VALIDATIONS
  ========================== */

  // Email validation
  const isEmailValid = useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    return emailRegex.test(email);
  }, [email]);

  // Password rules
  const passwordChecks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };

  const isPasswordValid = Object.values(passwordChecks).every(Boolean);

  // Confirm password match
  const isConfirmPasswordValid =
    confirmPassword.length > 0 && password === confirmPassword;

  // Final form validity
  const isFormValid = isEmailValid && isPasswordValid && isConfirmPasswordValid;

  /* =========================
     PASSWORD STRENGTH
  ========================== */

  const getPasswordStrength = () => {
    const score = Object.values(passwordChecks).filter(Boolean).length;
    if (score <= 2) return { label: "Weak", color: "danger", value: 25 };
    if (score === 3) return { label: "Medium", color: "warning", value: 50 };
    if (score === 4) return { label: "Good", color: "info", value: 75 };
    return { label: "Strong", color: "success", value: 100 };
  };

  const strength = getPasswordStrength();

  /* =========================
     FORM SUBMIT
  ========================== */

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage({ text: "", type: "" });

    // Show errors using your updated validation
    if (!email) {
      setMessage({ text: "Email is required", type: "error" });
      return;
    }
    if (!isEmailValid) {
      setMessage({ text: "Please enter a valid email", type: "error" });
      return;
    }

    if (!password) {
      setMessage({ text: "Password is required", type: "error" });
      return;
    }
    if (!isPasswordValid) {
      setMessage({
        text: "Password must be at least 8 characters and include uppercase, lowercase, number, and special character.",
        type: "error",
      });
      return;
    }

    if (!isConfirmPasswordValid) {
      setMessage({ text: "Passwords do not match", type: "error" });
      return;
    }

    try {
      setIsLoading(true);
      const response = await api.post("user/signup/email", {
        email,
        password,
        confirmPassword,
      });

      if (response.data.status === "success") {
        setMessage({ text: response.data.message, type: "success" });
        // Optional: navigate to login after success
        // setTimeout(() => navigate("/"), 2000);
      }
    } catch (err: any) {
      setMessage({
        text: err?.response?.data?.message || "Registration failed",
        type: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  /* =========================
     HELPER TO RENDER PASSWORD RULES
  ========================== */

  const renderRule = (condition: boolean, label: string) => (
    <div className="d-flex align-items-center mb-1">
      <i
        className={`me-2 ${
          condition ? "ti ti-check text-success" : "ti ti-x text-danger"
        }`}
      />
      <small className={condition ? "text-success" : "text-danger"}>
        {label}
      </small>
    </div>
  );

  return (
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden ">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleRegister}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <Link to={"https://voycell.com"}>
                  <ImageWithBasePath
                    src="assets/img/voycell-logo.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </Link>
              </div>

              <div className="mb-4">
                <h4 className="mb-2 fs-20">Register</h4>
                <p>Create a new VOYCELL account</p>
              </div>

              {/* ================= EMAIL ================= */}
              <div className="mb-3">
                <label className="col-form-label">Email Address</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-mail" />
                  </span>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={`form-control ${
                      email && !isEmailValid
                        ? "is-invalid"
                        : email && isEmailValid
                          ? "is-valid"
                          : ""
                    }`}
                    placeholder="john.doe@example.com"
                    required
                  />
                  {email && !isEmailValid && (
                    <small className="text-danger">
                      Please enter a valid email
                    </small>
                  )}
                </div>
              </div>

              {/* ================= PASSWORD ================= */}
              <div className="mb-3">
                <label className="col-form-label">Password</label>
                <div className="pass-group">
                  <input
                    type={passwordVisibility.password ? "text" : "password"}
                    className="pass-input form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="*********"
                    required
                  />
                  <span
                    className={`ti toggle-passwords ${
                      passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={() => togglePasswordVisibility("password")}
                  ></span>
                </div>

                {password && (
                  <>
                    <div className="my-2">
                      <div className="progress" style={{ height: "6px" }}>
                        <div
                          className={`progress-bar bg-${strength.color}`}
                          style={{ width: `${strength.value}%` }}
                        />
                      </div>
                      <small className={`text-${strength.color} fw-medium`}>
                        Password strength: {strength.label}
                      </small>
                    </div>

                    <div className="mt-2">
                      {renderRule(
                        passwordChecks.length,
                        "At least 8 characters",
                      )}
                      {renderRule(passwordChecks.uppercase, "Uppercase letter")}
                      {renderRule(passwordChecks.lowercase, "Lowercase letter")}
                      {renderRule(passwordChecks.number, "One number")}
                      {renderRule(passwordChecks.special, "Special character")}
                    </div>
                  </>
                )}
              </div>

              {/* ================= CONFIRM PASSWORD ================= */}
              <div className="mb-3">
                <label className="col-form-label">Confirm Password</label>
                <div className="pass-group">
                  <input
                    type={
                      passwordVisibility.confirmPassword ? "text" : "password"
                    }
                    className={`pass-input form-control ${
                      confirmPassword && !isConfirmPasswordValid
                        ? "is-invalid"
                        : confirmPassword && isConfirmPasswordValid
                          ? "is-valid"
                          : ""
                    }`}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="*********"
                    required
                  />
                  <span
                    className={`ti toggle-passwords ${
                      passwordVisibility.confirmPassword
                        ? "ti-eye"
                        : "ti-eye-off"
                    }`}
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  ></span>
                </div>
                {confirmPassword && !isConfirmPasswordValid && (
                  <small className="text-danger">Passwords do not match</small>
                )}
              </div>


              {/* ================= MESSAGE ALERT ================= */}
              {message.text && (
                <div className="mb-3">
                  <div
                    className={`alert ${
                      message.type === "success"
                        ? "alert-success"
                        : "alert-danger"
                    } fw-medium`}
                  >
                    {message.text}
                  </div>
                </div>
              )}

              {/* ================= TERMS ================= */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="form-check form-check-md d-flex align-items-center">
                  {/* <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue=""
                    id="checkebox-md"
                    defaultChecked
                  /> */}
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkebox-md"
                    checked={isTermsChecked}
                    onChange={(e) => setIsTermsChecked(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="checkebox-md">
                    I agree to the{" "}
                    <Link to="https://voycell.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-primary link-hover">
                      Terms &amp; Conditions
                    </Link>
                  </label>
                </div>
              </div>

              {/* ================= SUBMIT ================= */}
              <div className="mb-3">
                {/* <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isLoading || !isFormValid}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Signing Up...
                    </>
                  ) : (
                    "Sign Up"
                  )}
                </button> */}
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={isLoading || !isFormValid || !isTermsChecked}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Signing Up...
                    </>
                  ) : (
                    "Sign Up"
                  )}
                </button>
              </div>

              <div className="mb-3">
                <h6>
                  Already have an account?{" "}
                  <Link to="/" className="text-purple link-hover">
                    Sign In Instead
                  </Link>
                </h6>
              </div>

              <div className="text-center">
                <p className="fw-medium text-gray">
                  Copyright © 2026 - VOYCELL
                </p>
              </div>
            </div>
          </form>
        </div>
        <div className="d-flex flex-wrap w-50 vh-100 account-bg-02"></div>
      </div>
    </div>
  );
};

export default Register;
